'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'star-half-stroke';
var width = 576;
var height = 512;
var aliases = ["star-half-alt"];
var unicode = 'f5c0';
var svgPathData = ['M28 171.5l127.5 127.7-28.1 178.2 152.8-77.7 0-401.5-74 145-178.2 28.3z', 'M438 304.7l143.9-144.1-201.1-32-92.6-181.4-92.6 181.4-201.1 32 143.9 144.1-31.7 201.2 181.5-92.3 181.5 92.3-31.7-201.2zM296.2-1.9l74 145 178.2 28.3-127.5 127.7 28.1 178.2-152.8-77.7 0-401.5zm-16 0l0 401.5-152.8 77.7 28.1-178.2-127.5-127.7 178.2-28.3 74-145z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;